import { GridFilterOperator } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { CustomDateRangeInput } from '../dateRange';
import { getDateRangeFilterFn } from '../dateRange/getDateRangeFilterFn';
import { CustomFilterOperator } from './constants';

export const getDateRangeOperator = (
  intl: IntlShape,
  timezone: string
): GridFilterOperator => {
  return {
    label: formatTranslation(intl, FiltersTranslationKeys.operatorDateRange),
    value: CustomFilterOperator.DATE_RANGE,
    getApplyFilterFn: (item) => getDateRangeFilterFn(item, timezone),
    InputComponent: CustomDateRangeInput,
  };
};
